/**
 * Generated by orval v8.23.0 🍺
 * Do not edit manually.
 * Arbi API
 * OpenAPI spec version: 1.0.0
 */

/**
 * The `{id, display_name, role}` lite shape `SegmentOut.participant` carries.
 * `recall_participant_id` is never returned — it is provider-internal.
 */
export interface MarkerParticipantOut {
  id: string;
  display_name: string | null;
  role: string;
}
